import { useMemo } from 'react'
import { AlmanacFileCalendarEvent } from 'screens/Calendar/types'
import { providerFromChannelType } from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { SocialChannelType } from 'common/ShareSheetV2/Screens/Default/Default'
import { getPlatformValidators } from 'components/ArticlePostPreview/validators'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

type Input = {
  event: Pick<AlmanacFileCalendarEvent, 'scheduled_post' | 'channel' | 'content'>
}

type Output = {
  provider: ExternalIntegrationEnum | undefined
  validationErrors: string[]
}

export const useValidationErrors = (input: Input): Output => {
  const { event } = input
  const { scheduled_post, channel, content } = event

  const provider = providerFromChannelType[channel as SocialChannelType]
  const validators = provider ? getPlatformValidators(provider, channel) : null

  const mediaObjects = useMemo(
    () => scheduled_post?.media_objects ?? [],
    [scheduled_post?.media_objects]
  )
  const hasPostMedia = !!scheduled_post

  const validationErrors = useMemo(
    () =>
      validators
        ? [
            ...validators.validateContent(content || ''),
            ...(hasPostMedia
              ? [
                  ...validators.validateFiles(mediaObjects),
                  ...validators.validateVideosSize(mediaObjects),
                  ...validators.validateImagesSize(mediaObjects),
                  ...validators.validateVideosDuration(mediaObjects),
                  ...validators.validateVideosAspectRatio(mediaObjects),
                  ...validators.validateVideosFormat(mediaObjects),
                  ...validators.validateVideosCount(mediaObjects),
                ]
              : []),
          ]
        : [],
    [validators, hasPostMedia, mediaObjects, content],
  )

  return { provider, validationErrors }
}
